function validatePageNumber(accessedPage: number, maxPages: number) {
  if (typeof accessedPage !== 'number') return 1

  if (accessedPage > maxPages) return maxPages

  if (accessedPage <= 0) return 1

  return accessedPage
}

export default validatePageNumber
